import {ConnectedComponent} from '@lib/ConnectedComponent';

export class KvButton extends ConnectedComponent {
  checkbox: HTMLInputElement[] = [];

  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  didMount() {
    this.checkbox = [
      ...document.querySelectorAll('input[name="your-category"]'),
    ] as HTMLInputElement[];

    this.on('click', this.onClick);
  }

  onClick() {
    this.checkbox.map((c) => {
      c.checked = true;
      c.dispatchEvent(new Event('change'));
    });
  }
}
